export default __webpack_public_path__ + "static/media/Group 15@3x.ba864b8a.png";